  /* eslint-disable array-callback-return */
  /* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { getBenefits } from './constants';
import { CostUnit, displayCost } from 'utilities/currencyFormatter';

import { Document, Page, View, Text, StyleSheet, Image } from '@react-pdf/renderer';

import logoTrcGlobal from './images/trc-full-logo-condensed.jpg';
import { getTotalEstimateAmount } from './utils';

  const styles = StyleSheet.create({
    page: {
      flexDirection: 'row',
      backgroundColor: '#efefef', // light gray background
    },
    section: {
      margin: 10,
      padding: 10,
      flexGrow: 1,
    },
  });

  const DownloadableDoc = (props) => {
    const { distance, estimateInfo, perDiemRate, perDiemMealRate, avgHomesalePrice, avgHomesalePriceOrigin, flightCost, homefindingDays, applyTaxGrossUp, autoShipmentCost, getOptionCost, topLevelInputOneId, topLevelInputTwoId, topLevelInputThreeId, topLevelInputFourId, topLevelInputFive, topLevelInputSix, topLevelInputSeven, topLevelInputEight, topLevelInputNine, grossUpAmount, savedBenefits } = props;

    const homeSaleIsDirectReimbursement = topLevelInputFive !== undefined ? topLevelInputFive : estimateInfo.topLevelInputFive;
    const total = savedBenefits ? getTotalEstimateAmount(props.benefits, savedBenefits, homeSaleIsDirectReimbursement, topLevelInputSix, topLevelInputSeven, topLevelInputEight, topLevelInputNine, avgHomesalePrice, avgHomesalePriceOrigin, props.applyTaxGrossUp, getOptionCost, estimateInfo.grossUpPercentage || props.grossUpPercentage || 60) : 0;

    return (
        <Document>
            <Page size="A4">
                <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#de3f18', padding: '5px 0px 5px 5px' }}>
                    <Text style={{ color: '#ffffff', fontSize: 14}}>The prices contributing to the cost calculator are purely estimates based on similar moves. The actual costs could vary.</Text>
                </View>
                <View style={{ margin: 10, marginBottom: 15, maxWidth: '200px' }}>
                    <Image src={logoTrcGlobal} />
                </View>
                <View style={styles.page}>
                    <View style={styles.section}>
                        <Text style={{ fontSize: 12}}>{estimateInfo.transfereeName}</Text>
                        <Text style={{ fontSize: 12}}>{estimateInfo.reloPolicy}</Text>
                        <Text style={{ fontSize: 12}}>Exported on {(new Date()).toLocaleDateString()}</Text>
                    </View>
                    <View style={styles.section}>
                        <Text style={{ fontSize: 12}}>From: {estimateInfo.origin.city}, {estimateInfo.origin.state}</Text>
                        <Text style={{ fontSize: 12}}>To: {estimateInfo.destination.city}, {estimateInfo.destination.state}</Text>
                        <Text style={{ fontSize: 12}}>{distance} Miles</Text>
                    </View>
                    <View style={styles.section}>
                        <Text style={{ fontSize: 12}}>{estimateInfo.accompanyingAdults} Family Member(s)</Text>
                    </View>
                </View>
                <View style={styles.section}>
                    <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: 20, marginBottom: 20 }}>
                        <Text style={{ fontSize: 14, fontWeight: 'heavy' }}>Estimate Total: {displayCost(total, CostUnit.CURRENCY)} {applyTaxGrossUp ? '(Grossed Up)' : ''} </Text>
                    </View>

                    {props.savedBenefits.map((sb) => {
                        let staticBenefit = getBenefits(perDiemRate, perDiemMealRate, avgHomesalePrice, avgHomesalePriceOrigin, flightCost, homefindingDays, autoShipmentCost, distance).find((b) => b.benefitNumber === sb.benefitNumber);

                        let totalBenefitCost = 0;

                        if (staticBenefit.customTotal) {
                            if (sb) {
                              totalBenefitCost = sb.cost;
                            } else {
                              totalBenefitCost = 3000;
                            }
                        } else if (staticBenefit.customBenefit) {
                            if (sb) {
                                // Deduplicate options before calculating total to prevent double-counting
                                const deduplicatedOptions = sb.options.filter((opt, index, self) => 
                                  index === self.findIndex(o => o.optionNumber === opt.optionNumber)
                                );
                                totalBenefitCost = deduplicatedOptions.reduce((total, o) => total + Number(o.customCost), 0);
                            } else {
                                totalBenefitCost = 0;
                            }
                        } else {
                            if (sb) {
                                totalBenefitCost = staticBenefit.options.filter((opt) => sb.options.find((csbo) => csbo.optionNumber === opt.optionNumber)).reduce((total, o) => total + getOptionCost(o, sb.options.find((csbo) => csbo.optionNumber === o.optionNumber)), 0);
                                totalBenefitCost += sb.customLineChecked ? Number(sb.customLineCost) : 0;
                            } else {
                                totalBenefitCost = staticBenefit.options.reduce((total, o) => total + o.cost, 0);
                            }
                        }

                        let topLevelSelectionText = '';

                        if (staticBenefit.topLevelInputOne) {
                            const inputOneId = topLevelInputOneId !== undefined ? topLevelInputOneId : estimateInfo.topLevelInputOneId;
                            const inputTwoId = topLevelInputTwoId !== undefined ? topLevelInputTwoId : estimateInfo.topLevelInputTwoId;
                            const optionOneDetails = staticBenefit.topLevelInputOne.options.find((details) => details.id === inputOneId);
                            const optionTwoDetails = staticBenefit.topLevelInputTwo.options.find((details) => details.id === inputTwoId);
                            topLevelSelectionText = `(${optionOneDetails ? optionOneDetails.label : ''}, ${optionTwoDetails ? optionTwoDetails.label : ''})`;
                        } else if (staticBenefit.topLevelInputThree) {
                            const inputThreeId = topLevelInputThreeId !== undefined ? topLevelInputThreeId : estimateInfo.topLevelInputThreeId;
                            const optionThreeDetails = staticBenefit.topLevelInputThree.options.find((details) => details.id === inputThreeId);
                            topLevelSelectionText = `(${optionThreeDetails ? optionThreeDetails.label : ''})`;
                        } else if (staticBenefit.topLevelInputFour) {
                            const inputFourId = topLevelInputFourId !== undefined ? topLevelInputFourId : estimateInfo.topLevelInputFourId;
                            const optionFourDetails = staticBenefit.topLevelInputFour.options.find((details) => details.id === inputFourId);
                            topLevelSelectionText = `(${optionFourDetails ? optionFourDetails.label : ''})`;
                        }

                        return (
                            <View>
                                <View style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                    <View style={{width: '33%'}}>
                                        <Text color="primary" style={{ fontSize: 13, fontWeight: 'bold', textDecoration: 'underline' }}>{staticBenefit.name}</Text>
                                    </View>
                                    <View style={{width: '33%'}}>
                                        <View style={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                                            <Text style={{ fontSize: 13, fontWeight: 'bold' }}>{topLevelSelectionText}</Text>
                                        </View>
                                    </View>
                                    <View style={{width: '33%'}}>
                                        <View style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
                                            <Text variant="subtitle1" style={{ fontSize: 13, fontWeight: 'bold', textDecoration: 'underline' }}>{displayCost(totalBenefitCost, CostUnit.CURRENCY)}</Text>
                                        </View>
                                    </View>
                                </View>

                                <View style={{paddingBottom: '20px', borderTop: '1px solid #000'}}>
                                    {sb.options.map((savedOpt) => {
                                        let staticOpt = staticBenefit.options.find((opt) => opt.optionNumber === savedOpt.optionNumber);
                                        if (staticOpt) {
                                            let optionText = '';
                                            let selectionText = '';
                                            if (staticOpt.selections && savedOpt && staticOpt.selections.find((os) => os.selectionId === savedOpt.selectionId)) {
                                                optionText = staticOpt.description;
                                                selectionText = `(${staticOpt.selections.find((os) => os.selectionId === savedOpt.selectionId).text})`;
                                            } else if (savedOpt && savedOpt.customDescription) {
                                                optionText = savedOpt.customDescription;
                                            } else if (savedOpt && savedOpt.selectionId && staticOpt.freeNumberField) {
                                                optionText = staticOpt.description;
                                                selectionText = `(${savedOpt.selectionId} ${staticOpt.freeNumberMultiplier})`;
                                            } else if (savedOpt && staticOpt.optionNumber === 21 && homeSaleIsDirectReimbursement) {
                                                optionText = 'Direct reimbursement (Subject to gross up)';
                                            } else if (staticBenefit.customTotal) {
                                                selectionText = sb.isTaxable ? '(Grossed Up)' : '(Not Grossed Up)';
                                            } else {
                                                optionText = staticOpt.description;
                                            }

                                            return (
                                                <View style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingTop: '5px', paddingBottom: '5px'}}>
                                                    <View style={{width: '33%'}}>
                                                        <Text style={{ fontSize: 12}}>{optionText}</Text>
                                                    </View>
                                                    <View style={{width: '33%'}}>
                                                        <View style={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                                                            <Text style={{ fontSize: 12}}>{selectionText}</Text>
                                                        </View>
                                                    </View>
                                                    <View style={{width: '33%'}}>
                                                        <View style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
                                                            {!staticOpt.customTotal && (
                                                                <Text style={{ fontSize: 12}}>{displayCost(getOptionCost(staticOpt, savedOpt, staticBenefit), CostUnit.CURRENCY)}</Text>
                                                            )}
                                                            {staticOpt.customTotal && (
                                                                <Text style={{ fontSize: 12}}>{displayCost(Number(sb.cost), CostUnit.CURRENCY)}</Text>
                                                            )}
                                                        </View>
                                                    </View>
                                                </View>
                                            )
                                        }
                                    })}

                                    {sb && sb.customLineChecked && (
                                        <View style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingTop: '5px', paddingBottom: '5px'}}>
                                            <Text style={{ fontSize: 12}}>{sb.customLineDescription} </Text>
                                            <Text style={{ fontSize: 12}}>{displayCost(Number(sb.customLineCost), CostUnit.CURRENCY)}</Text>
                                        </View>
                                    )}
                                </View>
                            </View>
                        )
                    })}

                    {applyTaxGrossUp && (
                        <View>
                            <View style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                <Text color="primary" style={{ fontSize: 13, fontWeight: 'bold', textDecoration: 'underline' }}>Gross Up Amount</Text>
                                <Text color="primary" style={{ fontSize: 13, fontWeight: 'bold', textDecoration: 'underline' }}>{displayCost(grossUpAmount, CostUnit.CURRENCY)}</Text>
                            </View>
                        </View>
                    )}
                </View>
            </Page>
        </Document>
    )
  }

  
  export default DownloadableDoc;
  